import axios from 'axios';

export const SignerService = async ({
  method = 'GET',
  url,
  body = null,
}) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };

    const response = await axios({
      method,
      url,
      data: method !== 'GET' ? body : null,
      headers: headers,
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      const message = error.response.data?.message;
      return {
        status: 'error',
        message: message,
        statusCode: error.response.status,
      };
    }
  }
};
